/**
 * Flow F's six routes (F1–F6).
 *
 * `/account/notifications` (NT2 · খবরের পছন্দ) is NOT here: it belongs to WP-M, and F1
 * draws no notifications row.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { F1Account } from './F1Account.js';
import { F2Profile } from './F2Profile.js';
import { F3Addresses } from './F3Addresses.js';
import { F4Payment } from './F4Payment.js';
import { F5Language } from './F5Language.js';
import { F6Security } from './F6Security.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (account · অ্যাকাউন্ট); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const accountRoutes: RouteObject[] = withSurfaceStates('account', [
  { path: '/account', element: <F1Account /> },
  { path: '/account/profile', element: <F2Profile /> },
  { path: '/account/addresses', element: <F3Addresses /> },
  { path: '/account/payment', element: <F4Payment /> },
  { path: '/account/language', element: <F5Language /> },
  { path: '/account/security', element: <F6Security /> },
]);
